import { collection } from 'firebase/firestore';
import { useFirestore, useFirestoreCollection } from 'reactfire';

// 2026-09-01: for the Reports dashboard's per-submitter breakdown -- resolves a
// title's `creator` UID to a real name/email. `userinfo/{uid}` already exists for
// this exact purpose (created by add_portal_user.py for every portal user, keyed by
// their Auth uid, {fname, lname, email, allowBucketWrite} -- see PageHeader.js's
// useUserInfo for the single-doc equivalent of this) and firestore.rules already
// allows `allow read: if true` on the whole collection, so this needs no new
// backend infra, no Cloud Function, and no rules change -- just reads the same
// small (one doc per portal user, 7 today) collection everything else already does.
export function useAllUserInfo() {
    const firestore = useFirestore();
    const userinfoCollection = collection(firestore, 'userinfo');
    const { status, data: userinfoDocs } = useFirestoreCollection(userinfoCollection);

    if (status === 'loading') {
        return undefined;
    }

    const byUid = {};
    userinfoDocs.forEach(doc => {
        byUid[doc.id] = doc.data();
    });

    return byUid;
}

// Human-readable label for a creator UID, given the map from useAllUserInfo() above.
//
// 2026-09-01: checked live -- ALL 7 creator UIDs (including the one flagged as "no
// resolvable Firebase Auth record") actually DO have a userinfo doc; that one
// (Michael Schwinges, mike@findflix.com, 16 legacy titles) has an explicit
// `active: false` field on it, which is a much better signal than a generic
// anonymized fallback -- shown as "(inactive)" rather than hiding who it was. The
// generic "Former user" fallback below is kept as a genuine defensive case (a
// creator UID with literally no userinfo doc at all), which isn't a real case
// today but costs nothing to handle gracefully rather than erroring.
export function labelForUid(uid, userinfoByUid) {
    if (!uid) {
        return 'Unknown submitter';
    }

    const info = userinfoByUid && userinfoByUid[uid];
    if (!info) {
        return `Former user (${uid.slice(0, 8)}…)`;
    }

    const name = [info.fname, info.lname].filter(Boolean).join(' ');
    const base = (name && info.email) ? `${name} (${info.email})` : (name || info.email || `Unknown (${uid.slice(0, 8)}…)`);
    return info.active === false ? `${base} (inactive)` : base;
}
